/**
 * 出力の正規化（docs/spec/judge.md §2）。swift-classroom の playground.js と同じ結果にする。
 * 1. null / undefined は空文字列 2. 行ごとに末尾の [ \t\r]+ を除く 3. 末尾の \n+ を除く。
 */
export function normalizeOutput(s: string | null | undefined): string {
  return (s ?? '')
    .split('\n')
    .map((line) => line.replace(/[ \t\r]+$/, ''))
    .join('\n')
    .replace(/\n+$/, '');
}

/** `normalizeOutput(actual) === normalizeOutput(expected)`（judge.md §2 末尾）。 */
export function outputsMatch(
  actual: string | null | undefined,
  expected: string | null | undefined,
): boolean {
  return normalizeOutput(actual) === normalizeOutput(expected);
}
